__turbopack_context__.v({
  "appearance": "spellbook-module__QxBe3W__appearance",
  "circle": "spellbook-module__QxBe3W__circle",
  "circleTitle": "spellbook-module__QxBe3W__circleTitle",
  "controls": "spellbook-module__QxBe3W__controls",
  "error": "spellbook-module__QxBe3W__error",
  "lead": "spellbook-module__QxBe3W__lead",
  "levels": "spellbook-module__QxBe3W__levels",
  "page": "spellbook-module__QxBe3W__page",
  "price": "spellbook-module__QxBe3W__price",
  "result": "spellbook-module__QxBe3W__result",
  "resultTitle": "spellbook-module__QxBe3W__resultTitle",
  "spells": "spellbook-module__QxBe3W__spells",
  "total": "spellbook-module__QxBe3W__total",
  "totals": "spellbook-module__QxBe3W__totals",
});
